export default __webpack_public_path__ + "static/Jeffrey_Tsang-4e305c574aac66411c3ee2d841533ade.jpg";